import React from "react";

const DisplayImage = ({ url, name, height = 50, width = 50 }) => {



    return (
        <div>
            <img
                src={url}
                alt={name}
                style={{
                    width,
                    height,
                    borderRadius: '50%',
                    objectFit: 'cover'
                }}
            />
        </div>
    );
};

export default DisplayImage;
